import api from '../../api'
import { endpoints } from '../../apiCommons'
import localCompany from '../localStorage/localCompany'

const getEmployees = async ({
  page,
  limit,
  enterprice,
  sEstado = [],
  sSucursal = '',
  sCentroCosto = '',
  sGrupo = '',
  sNombre = '',
  sTipoEmpleado = '',
  sRut = '',
  sOrderby = '',
  bAsc = true,
  bOmitirPaginacion = false,
  bReporte = false,
  bDiscount = false,
}) => {
  const token = localStorage.getItem('token')
  const url = bDiscount ? endpoints.employee_list_lite : endpoints.employee_list
  return api.get(url, {
    params: {
      nPagina: page,
      nEmpleadosPagina: limit,
      sEmpresa: enterprice || 0,
      sSucursal,
      sCentroCosto,
      sGrupo,
      sNombre,
      sEstado,
      sTipoEmpleado,
      sRut,
      sOrderby,
      bAsc,
      bOmitirPaginacion,
      bReporte,
      bDiscount: bDiscount ? 1 : 0,
    },
    headers: { token },
  })
}
const getAllEmployees = async ({
  page,
  limit,
  enterprice,
  sEstado = [],
  sSucursal = '',
  sCentroCosto = '',
  sGrupo = '',
  sNombre = '',
  sTipoEmpleado = '',
  sRut = '',
  sOrderby = '',
  bAsc = true,
  bOmitirPaginacion = false,
  bDiscount = false,
}) => {
  const token = localStorage.getItem('token')
  const url = bDiscount ? endpoints.employee_list_lite : endpoints.employee_list
  return api.get(url, {
    params: {
      nPagina: page,
      nEmpleadosPagina: limit,
      sEmpresa: enterprice || 0,
      sSucursal,
      sCentroCosto,
      sGrupo,
      sNombre,
      sEstado,
      sTipoEmpleado,
      sRut,
      sOrderby,
      bAsc,
      bOmitirPaginacion,
      bDiscount: bDiscount ? 1 : 0,
    },
    headers: { token },
  })
}

const updateStatus = async (status, employees) => {
  const token = localStorage.getItem('token')
  return api.put(
    endpoints.change_employee_status,
    {
      sEstado: status,
      cDatosEmpleados: [
        ...employees.map((element) => ({
          sEmpresa: element.sEmpresa,
          sEmpleado: element.sEmpleado,
          sComentario: '',
        })),
      ],
    },
    { headers: { token } },
  )
}

const createIndividualEmployee = async ({ data }) => createEmployees([data])

const createEmployees = async (employees) => {
  const token = localStorage.getItem('token')
  return api.post(
    endpoints.create_account,
    {
      lDatosCuenta: employees,
    },
    { headers: { token } },
  )
}

const validateCreateEmployeesMasive = async (employees) => {
  const token = localStorage.getItem('token')
  return api.post(
    endpoints.create_account,
    {
      lDatosCuenta: employees,
    },
    {
      headers: { token },
      params: {
        bSoloValidar: true,
      },
    },
  )
}

const employeeDetails = (sEmpleado) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.employeeDetails, {
    params: {
      sEmpresa,
      sEmpleado,
    },
    headers: { token },
  })
}

const sendSecurityPin = async (sEmpleado) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.securityPin, {
    params: {
      sEmpresa,
      sEmpleado,
    },
    headers: { token },
  })
}

const editEmployee = async ({
  sEmpleado,
  sNombre,
  sApellidoPaterno,
  sAPellidoMaterno,
  dNacimiento,
  idGrupo,
  sSucursal = null,
  sCentroCosto,
  sSexo,
  sTelefonoMovil = '',
  sTelefonoFijo = '',
}) => {
  const token = localStorage.getItem('token')
  const {
    sEmpresa,
    // lGrupo,
    // // sSucursal: Sucursal,
    // sCentroCosto: CentroCosto,
  } = localCompany.getCompanyData()
  return api.put(
    endpoints.editEmpoyee,
    {
      sEmpleado,
      sEmpresa: sEmpresa,
      sNombre,
      sApellidoPaterno,
      sApellidoMaterno: sAPellidoMaterno,
      dNacimiento,
      sGrupo: idGrupo,
      sSucursal: sSucursal,
      sCentroCosto: sCentroCosto,
      sSexo,
      sTelefonoMovil: sTelefonoMovil || '',
      sTelefonoFijo: sTelefonoFijo || '',
    },
    { headers: { token } },
  )
}

const accountsRequested = async (params) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = await localCompany.getCompanyData()
  return api
    .get(endpoints.accountsRequested, {
      params: { sEmpresa, ...params },
      headers: { token },
    })
    .then((res) => res.data)
}

const validateMassiveTermination = async (data) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = await localCompany.getCompanyData()
  return api.post(
    endpoints.validateMassiveTermination,
    { lrut: data, sEmpresa },
    {
      headers: { token },
    },
  )
}

const massiveTermination = async (data) => {
  const token = localStorage.getItem('token')

  const { sEmpresa } = await localCompany.getCompanyData()
  return api.post(
    endpoints.massiveTermination,
    { sEmpresa, lEmpleado: data },
    { headers: { token } },
  )
}
const getContactosEmpresa = async () => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getCompanyData()
  return api.get(endpoints.listaContactosEmpresa, {
    params: { sEmpresa },
    headers: { token },
  })
}

const getContacts = async (idContacto) => {
  const token = localStorage.getItem('token')

  const { sEmpresa } = await localCompany.getCompanyData()
  return api.get(endpoints.contactsDetails, {
    params: { sEmpresa, idContacto },
    headers: { token },
  })
}

const getInactiveUsers = async ({
  nPagina = 1,
  nUsuariosPagina = 5,
  nDias = 90,
  bOmitirPaginacion = false,
}) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = await localCompany.getCompanyData()
  return api.get(endpoints.inactiveUserList, {
    params: { nPagina, nUsuariosPagina, nDias, bOmitirPaginacion, sEmpresa },
    headers: {
      token,
    },
  })
}

const getListaLogContactos = async (idContacto) => {
  const token = localStorage.getItem('token')
  const { sEmpresa, sEstablecimiento } = localCompany.getCompanyData()
  return api.get(endpoints.listaLogContactos, {
    params: {
      sCliente: sEmpresa,
      sEstablecimiento,
      ...(idContacto && { idContacto }),
    },
    headers: { token },
  })
}

const editManager = async ({
  idContacto = '',
  sNombreContacto = '',
  sApellidoPaterno = '',
  sApellidoMaterno = '',
  sRut = '',
  sCargo = '',
  sTelefonoFijo = '',
  sTelefonoMovil = '',
  sEmailContacto = '',
  sTipoContacto = '',
}) => {
  const token = localStorage.getItem('token')
  return api.post(
    endpoints.editManager,
    {
      idContacto,
      sNombreContacto,
      sApellidoPaterno,
      sApellidoMaterno,
      sRut,
      sCargo,
      sTelefonoFijo,
      sTelefonoMovil,
      sEmailContacto,
      sTipoContacto,
    },
    { headers: { token } },
  )
}

export default {
  getEmployees,
  updateStatus,
  createIndividualEmployee,
  createEmployees,
  employeeDetails,
  sendSecurityPin,
  editEmployee,
  accountsRequested,
  getAllEmployees,
  validateMassiveTermination,
  massiveTermination,
  getContacts,
  getContactosEmpresa,
  getInactiveUsers,
  getListaLogContactos,
  editManager,
  validateCreateEmployeesMasive,
}
